module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_25_30.9d651ee0.png";